import Reveal from "./reveal";
import RevealContent from "./reveal-content";
Reveal.Content = RevealContent;
export default Reveal;
//# sourceMappingURL=index.js.map